import { setTelemetrySharingIssueState } from 'owa-attachment-block-on-send';
import { mutator } from 'satcheljs';
import {
    composeValidationFailedForMessage,
    composeValidationFailedForMessageWithSharingIssueForceSend,
    composeValidationFailedForMessageWithSharingIssueTimeDialogOpen,
    messageSuccessfullySent,
} from '../actions/internalActions';
import { ValidatedAttachmentType } from '../store/schema/ValidatedAttachmentType';
import { getStore } from '../store/store';

function createValidatedAttachmentTypeForSharingIssue(composeId: string) {
    const allTelemetryData = getStore().telemetryDataForFailedValidation.get(composeId);
    const sharingIssueTelemetryData = {
        forceSend: null,
        timeBlockingDialogOpen: null,
        sharingTipId: null,
        errorSource: null,
        totalLinkCount: 0,
        newLinkCount: 0,
    };
    getStore().telemetryDataForFailedValidation.set(composeId, {
        ...allTelemetryData,
        [ValidatedAttachmentType.SharingIssue]: sharingIssueTelemetryData,
    });
}

function getOrCreateTelemetryDataForSharingIssue(composeId: string) {
    let telemetryData = getStore().telemetryDataForFailedValidation.get(composeId);
    if (!telemetryData || !telemetryData[ValidatedAttachmentType.SharingIssue]) {
        createValidatedAttachmentTypeForSharingIssue(composeId);
    }
    return getStore().telemetryDataForFailedValidation.get(composeId);
}

mutator(composeValidationFailedForMessage, ({ composeId, forceSend, validatedAttachmentType }) => {
    const allTelemetryData = getStore().telemetryDataForFailedValidation.get(composeId);
    getStore().telemetryDataForFailedValidation.set(composeId, {
        ...allTelemetryData,
        [validatedAttachmentType]: { forceSend: forceSend },
    });
});

mutator(
    setTelemetrySharingIssueState,
    ({ composeId, sharingTipId, errorSource, totalLinkCount, newLinkCount }) => {
        const telemetryData = getOrCreateTelemetryDataForSharingIssue(composeId);
        telemetryData[ValidatedAttachmentType.SharingIssue].sharingTipId = sharingTipId;
        telemetryData[ValidatedAttachmentType.SharingIssue].errorSource = errorSource;
        telemetryData[ValidatedAttachmentType.SharingIssue].totalLinkCount = totalLinkCount;
        telemetryData[ValidatedAttachmentType.SharingIssue].newLinkCount = newLinkCount;
        getStore().telemetryDataForFailedValidation.set(composeId, telemetryData);
    }
);

mutator(composeValidationFailedForMessageWithSharingIssueForceSend, ({ composeId, forceSend }) => {
    const telemetryData = getStore().telemetryDataForFailedValidation.get(composeId);
    if (telemetryData) {
        telemetryData[ValidatedAttachmentType.SharingIssue].forceSend = forceSend;
        getStore().telemetryDataForFailedValidation.set(composeId, telemetryData);
    }
});

mutator(
    composeValidationFailedForMessageWithSharingIssueTimeDialogOpen,
    ({ composeId, timeDialogOpen }) => {
        const telemetryData = getOrCreateTelemetryDataForSharingIssue(composeId);
        telemetryData[ValidatedAttachmentType.SharingIssue].timeBlockingDialogOpen = timeDialogOpen;
        getStore().telemetryDataForFailedValidation.set(composeId, telemetryData);
    }
);

mutator(messageSuccessfullySent, ({ composeId }) => {
    getStore().telemetryDataForFailedValidation.delete(composeId);
});
